import tripStates from "./constants/tripStates";

export const sortPointsByPosition = (tripPoints) => [
    ...tripPoints.sort((a, b) => (a.pointType === "pickup" ? -1 : a.position - b.position)),
];

export const getCurrentPointId = (tripPoints, currentTripPointId, tripStatus) => {
    const currentPointIndex = tripPoints.findIndex((trip) => +trip.id === currentTripPointId);
    if (currentPointIndex === -1) {
        return null;
    }
    const currentPoint =
        tripPoints[tripStatus === tripStates.MOVING ? currentPointIndex - 1 : currentTripPointId];

    return (currentPoint && +currentPoint.id) || currentTripPointId;
};

const hasActualPosition = (point) =>
    point && point.actualPosition !== null && point.actualPosition !== undefined;

const shouldIncludeInActualRoute = (point) =>
    hasActualPosition(point) || (!point.visited && point.actualPosition === null);

export const mapPointsToActualRoute = (tripPoints = []) => {
    if (!Array.isArray(tripPoints)) return [];

    return tripPoints
        .filter(shouldIncludeInActualRoute)
        .map((point) => {
            const attrs = point?.locationAttributes?.data?.attributes;
            return {
                actualPosition: hasActualPosition(point) ? Number(point.actualPosition) : null,
                arrivalTime: point.arrivalTime || null,
                departureTime: point.departureTime || null,
                locationAttributes: {
                    name: attrs?.name || null,
                    nameAr: attrs?.nameAr || null,
                },
                skipped: !point.visited,
            };
        })
        .sort((a, b) => {
            // First, sort by actualPosition (null values come last)
            if (a.actualPosition === null && b.actualPosition !== null) return 1;
            if (a.actualPosition !== null && b.actualPosition === null) return -1;
            if (a.actualPosition !== null && b.actualPosition !== null) {
                const positionComparison = Number(a.actualPosition) - Number(b.actualPosition);
                if (positionComparison !== 0) return positionComparison;
            }

            // If actualPosition is the same or both null, put skipped points after non-skipped points
            if (a.skipped && !b.skipped) return 1;
            if (!a.skipped && b.skipped) return -1;

            return 0;
        });
};
